import { Pipe, PipeTransform } from '@angular/core';
import { ProfilePhotoService } from '@mzima-client/sdk';

@Pipe({
  name: 'profilePhoto',
  pure: false,
})
export class ProfilePhotoPipe implements PipeTransform {
  constructor(private profilePhotoService: ProfilePhotoService) {}

  transform(userId: string | number, gravatarHash: string): string {
    const cached = this.profilePhotoService.getCachedPhotoUrl(userId);
    if (cached) return cached;
    return `//www.gravatar.com/avatar/${
      gravatarHash || '00000000000000000000000000000000'
    }?d=retro&s=40`;
  }
}
